import Icon from '../Icon';
import type { LucideIconData, LucideIconNode, LucideProps } from '../types';

export const __iconData: LucideIconData = {
  name: 'ship-cargo',
  size: 24,
  node: [
    ['path', { d: 'M12 15v-3', key: '1rb51w' }],
    ['path', { d: 'M12 2v2', key: 'tus03m' }],
    [
      'path',
      {
        d: 'M16.5 12V9a1 1 0 011-1h1a1 1 0 001-1V5a1 1 0 00-1-1h-13a1 1 0 00-1 1v2a1 1 0 001 1h1a1 1 0 011 1v3',
        key: '1byvar',
      },
    ],
    [
      'path',
      {
        d: 'M19.38 19c1.076-1.815 1.636-4.89 1.628-6.008a1 1 0 00-1-.992H3.984a1 1 0 00-1 .984c-.03 1.86.97 5.621 2.826 7.776',
        key: '1kvu1n',
      },
    ],
    [
      'path',
      {
        d: 'M2 20c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1',
        key: '1l8w7g',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ShipCargo
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTV2LTMiIC8+CiAgPHBhdGggZD0iTTEyIDJ2MiIgLz4KICA8cGF0aCBkPSJNMTYuNSAxMlY5YTEgMSAwIDAxMS0xaDFhMSAxIDAgMDAxLTFWNWExIDEgMCAwMC0xLTFoLTEzYTEgMSAwIDAwLTEgMXYyYTEgMSAwIDAwMSAxaDFhMSAxIDAgMDExIDF2MyIgLz4KICA8cGF0aCBkPSJNMTkuMzggMTljMS4wNzYtMS44MTUgMS42MzYtNC44OSAxLjYyOC02LjAwOGExIDEgMCAwMC0xLS45OTJIMy45ODRhMSAxIDAgMDAtMSAuOTg0Yy0uMDMgMS44Ni45NyA1LjYyMSAyLjgyNiA3Ljc3NiIgLz4KICA8cGF0aCBkPSJNMiAyMGMuNi41IDEuMiAxIDIuNSAxIDIuNSAwIDIuNS0yIDUtMiAxLjMgMCAxLjkuNSAyLjUgMXMxLjIgMSAyLjUgMWMyLjUgMCAyLjUtMiA1LTIgMS4zIDAgMS45LjUgMi41IDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/ship-cargo
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShipCargo = (props: LucideProps) => <Icon {...props} icon={__iconData} />;

export default ShipCargo;
